import { commonMediaKeys, fnFRowStandard, type FactoryKeyMap, type KeysConfig } from './common'

const factoryKeysWin: FactoryKeyMap = {
  ...fnFRowStandard,
  F10: '📢✕',
  F11: '📢➖',
  F12: '📢➕',
  '|_\\': 'LED_Color',
  '!_1': 'BT1',
  '@_2': 'BT2',
  '#_3': 'BT3',
  $_4: '24G',
  Delete: 'SideLED',
  Win_L: 'WIN_Lock',
  '↑': 'LED_Inc',
  '↓': 'LED_Dec',
  '←': 'LEDMode_Retreat',
  '→': 'LEDMode_Forward',
  V: 'ChargLED_Switch',
  Space_L: 'Show_Battery_Level',
}

export const a83airKeys: KeysConfig = {
  factoryKeys: {
    win: factoryKeysWin,
    mac: { ...factoryKeysWin },
  },
  mediaKeys: [...commonMediaKeys],
}
